module.exports = __webpack_public_path__ + "img/template_1.f5684aaa.png";